<template>
  <div class="relative rounded-[15px] border border-solid border-gray-light bg-white">
    <div class="text-b2 absolute -top-4 right-6 rounded-[4px]ß bg-purple-20 px-4 py-1" v-if='canBeRemoved && !this.isCar()'>
      Du har preliminär plats {{ queuePosition }}
    </div>

    <div class="grid grid-cols-1 gap-6 p-4 md:p-6 md:grid-cols-2">
      <div class="grid grid-cols-3 gap-4 md:gap-x-6 md:gap-y-2">
        <div class="row-span-2 aspect-square w-full md:row-span-4">
          <img
            v-if="noteofinterest.images.length > 0"
            :src="noteofinterest.images[0].url"
            alt="Bostad"
            class="h-full w-full rounded-[10px] object-cover"
          />
        </div>
        <div class="col-span-2 flex flex-col gap-2">
          <h3 class="text-t6">{{ noteofinterest.address }}</h3>
          <p class="text-b2">{{ noteofinterest.neighbourhood }}</p>
        </div>
        <p
          class="text-label col-span-full flex h-6 w-fit items-center rounded-sm bg-primary-30 px-2 py-2 uppercase md:col-span-2"
        >
          {{ getStatus(noteofinterest) }}
        </p>


        <p v-if="!canBeRemoved" class="text-b2 col-span-full md:col-span-2">Anmälningstiden gick
          ut <br /><span class="font-thick">{{ formatDate(noteofinterest.publishedTo) }}</span>. <br/>Du kan inte längre
          ta bort din intresseanmälan
        </p>
        <p v-else class="text-b2 col-span-full md:col-span-2">
          Sista dag för anmälan:
          <span class="font-thick">{{ formatDate(noteofinterest.publishedTo) }}</span>
        </p>
      </div>

      <div class="flex flex-col gap-2">
        <p class="text-b3">Nästa steg</p>

        <ul class="flex flex-col gap-2" v-if="canBeRemoved">
          <li class="flex gap-2">
            <div class="size-5">
              <IconCheckmark />
            </div>
            <p class="text-b3">Efter att anmälningstiden gått ut blir din anmälan bindande.</p>
          </li>
          <li class="flex gap-2">
            <div class="size-5">
              <IconCheckmark />
            </div>
            <p class="text-b3">
              Efter anmälningstiden gått ut skickas erbjudanden ut till de med flest köpoäng.
            </p>
          </li>
        </ul>
        <ul v-else>
          <li class="flex gap-2">
            <div class="size-5">
              <IconCheckmark />
            </div>
            <p class="text-b3">Vi handlägger och går igenom de inkomna intresseanmälningarna. De som står först på tur blir
              erbjuden visning.</p>
          </li>
        </ul>
      </div>
    </div>
    <div
      class="flex flex-col justify-end gap-2 border-t border-solid border-gray-light px-4 md:px-6 py-4 md:flex-row"
    >
      <Button
        variant="secondary"
        size="large"
        :to="{
          name: 'OfferVacancy',
          params: { id: noteofinterest.rentalObjectCode },
        }"
      >
        Läs mer om
        <span v-if="noteofinterest.caption == 'Bostad'">bostaden</span>
        <span v-if="noteofinterest.caption == 'fordonsplats'">parkeringsplatsen</span>
        <span v-if="noteofinterest.caption == 'lokal'">lokalen</span>
      </Button>

      <Button
        variant="danger"
        size="large"
        @click="removeInterest(noteofinterest.code)"
        :disabled="showLoader"
        v-if="canBeRemoved"
      >
        Ta bort intresseanmälan
        <template #icon-after>
          <IconTrashCan />
        </template>
      </Button>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import Button from '@/components/ui/button';
import IconTrashCan from '@/components/icons/IconTrashCan';
import IconCheckmark from '@/components/icons/IconCheckmark';
import { PARKING_FILTER_TYPES } from '@/config/constants'

export default {
  name: 'NoteInterestItem',
  components: {
    Button,
    IconCheckmark,
    IconTrashCan,
  },
  props: {
    noteofinterest: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      queuePosition: "...",
      showLoader: false,
    };
  },
  computed: {
    canBeRemoved() {
      return !!this.noteofinterest.publishedTo && !dayjs(this.noteofinterest.publishedTo).isBefore();
    }
  },

  watch: {
    'noteofinterest.code': {
      immediate: true,
      handler(newCode) {
        if (!newCode || !this.canBeRemoved || this.isCar()) {
          this.queuePosition = '-';
          return;
        }

        this.$store.cache
          .dispatch('fetchSingleObjectQueuePostion', newCode)
          .then(() => {
            let pos = this.$store.getters.getQueuePositionByCode(newCode);
            this.queuePosition = (pos > 0) ? pos : '-';
          })
          .catch(() => {
            this.queuePosition = '-';
          });
      },
    },
  },


  methods: {
    formatDate(date) {
      return dayjs(date).format('YYYY-MM-DD');
    },
    removeInterest(code) {
      this.showLoader = true;
      return this.$store.dispatch('removeNoteofInterest', code).finally(() => {
        this.showLoader = false;
      });
    },

    isCar() {
      if (this.noteofinterest) {
        return (
          this.noteofinterest.objectType == "parking"
        );
      }
    },

    getStatus (obj) {
      if (!this.canBeRemoved && obj.status.toLowerCase() == 'current') return 'Handläggs'
      else if (obj.status.toLowerCase() == 'current') return 'Anmält intresse'
      else return 'Handläggs'
    }
  },
};
</script>
